import React, { useEffect, useState } from 'react';

import scss from './ImageChip.module.scss';

function ImageChip({ onRemove, file, onError }) {
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => {
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [file]);

  return (
    <div className={scss.chip}>
      {previewUrl ? <img className={scss.previewImg} src={previewUrl} alt='' onError={onError} /> : null}

      <button type='button' className={scss.remove} onClick={onRemove} aria-label={`Remove image`}>
        ×
      </button>
    </div>
  );
}

export default ImageChip;
